import {logger} from 'yougile-util'
import {
  DataObjectId,
  SystemMessageUtils,
  TimelineFilterBackend,
  UserEventsByTime,
  UserEventsListLimitedReq,
  UserEventsListLimitedResp,
  youGileUserId
} from 'yougile-model'
import {Backend} from '@common/backend'
import {Sync} from './sync'

export interface UserEventsClientDataLimited {
  events: UserEventsByTime
  isEventsLeft: boolean
}

const emptyDataLimited: UserEventsClientDataLimited = {
  events: {},
  isEventsLeft: null
}

export class UserEventsClient {
  static getDataLimited(
    companyId: DataObjectId,
    count: number,
    filters: TimelineFilterBackend,
    taskId?: DataObjectId
  ): Promise<UserEventsClientDataLimited> {
    if (!companyId || !count) {
      return Promise.resolve(emptyDataLimited)
    }
    if (!Backend.features?.userEvents) {
      logger.log('User events not supported')
      return Promise.resolve(emptyDataLimited)
    }
    const req: UserEventsListLimitedReq = {
      ...Backend.loadCred(),
      companyId,
      count,
      filters,
      taskId
    }

    const hub = Sync.getCurrentSandbox().getHub(taskId)
    const extraEventsFromMessages: UserEventsClientDataLimited['events'] = {}
    if (hub) {
      const messages = hub.chat.messages.values()
      for (const message of messages) {
        if (SystemMessageUtils.isDeadline(message)) {
          if (filters.createdAt) {
            const timestamp = message.timestamp
            if (
              timestamp < filters.createdAt.start ||
              timestamp > filters.createdAt.end
            ) {
              continue
            }
          }
          extraEventsFromMessages[message.timestamp] = {
            type: 'deadlineFailed',
            user: youGileUserId,
            obj: hub.id
          }
        }
      }
    }

    return Backend.postJSON<UserEventsListLimitedResp>(
      '/data/user-events/list-limited',
      req
    ).then(res => {
      const events: UserEventsByTime = Object.fromEntries(
        Object.entries(res.events).map(([k, v]) => [
          k,
          {
            ...v,
            user: v.user ?? youGileUserId
          }
        ])
      )
      const allKeys = new Set([
        ...Object.keys(events),
        ...Object.keys(extraEventsFromMessages)
      ])
      const sortedKeys = Array.from(allKeys).sort().reverse()
      return {
        events: Object.fromEntries(
          sortedKeys.map(key => [
            key,
            events[Number(key)] || extraEventsFromMessages[Number(key)]
          ])
        ),
        isEventsLeft: res.isEventsLeft
      }
    })
  }
}
